import React, { useContext, useReducer, createContext } from 'react';



//prepares the dataLayer
export const StateContext = createContext();


//wrap up our app and provides the Data Layer 
export const StateProvider = ({ reducer, initialState, children }) => {
    return (
        <StateContext.Provider value={useReducer(reducer, initialState)}>
            {children}
        </StateContext.Provider>
    )
};



//Pull information from data layer
export const useStateValue = () => useContext(StateContext);
